module.exports = __webpack_public_path__ + "img/earth.acfb7cd4.png";